export default __webpack_public_path__ + "static/eric-37ea3dc03e1cb747089b876f918d07f6.png";